<template>
  <div class="columns is-multiline">
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <FormBrand v-model="element.brand"/>
    </div>
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <FormModel v-model="element.model"/>
    </div>
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputText name="Numero punti di regolazione" v-model="element.regulation_points" />
    </div>
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputText name="Numero livelli di temperatura" v-model="element.temperature_levels" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    element: Object
  }
}
</script>